import type { CorporateSiteNavigationApiModel } from '@gro-up/api/corporate'

export const useSiteNavigation = () =>
  useState<CorporateSiteNavigationApiModel | undefined>('siteNavigation', () => undefined)
